export default __webpack_public_path__ + "static/media/SearchIcon.e56152f7.svg";